import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgbdModalModule} from '../modal/modal.module';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {PipesModule} from '../pipes/pipes.module';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {SharedComponentsModule} from '../shared-components-module/shared-components.module';
import {ToastrModule} from 'ngx-toastr';
import {InvoiceHomeComponent} from './invoice-home/invoice-home.component';
import {EmailInvoiceMasterSheetComponent} from './dialogs/email-invoice-master-sheet/email-invoice-master-sheet.component';
import { EmailAllClientInvoicesComponent } from './dialogs/email-all-client-invoices/email-all-client-invoices.component';
import { EmailMonthlyAccountingReportComponent } from './dialogs/email-monthly-accounting-report/email-monthly-accounting-report.component';
import { DownloadHistoricalInvoicesComponent } from './dialogs/download-historical-invoices/download-historical-invoices.component';
import { DownloadAutopayReportComponent } from './dialogs/download-autopay-report/download-autopay-report.component';
import { DownloadOnetimePmtReportComponent } from './dialogs/download-onetime-pmt-report/download-onetime-pmt-report.component';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { PaymentModule } from '../shared-components-module/payments/payment.module';
import { InvoiceAddendumComponent } from './invoice-addendum/invoice-addendum.component';
import { CourtFeesAuditReportComponent } from './dialogs/court-fees-audit-report/court-fees-audit-report.component';
import { ResmanBillingReportComponent } from './dialogs/resman-billing-report/resman-billing-report.component';
import { AddendumUploadComponent } from './dialogs/addendum-upload/addendum-upload.component';


const routes: Routes = [
  {path: 'invoiceHome', component: InvoiceHomeComponent}
];

@NgModule({
    declarations: [
        InvoiceHomeComponent,
        EmailInvoiceMasterSheetComponent,
        EmailAllClientInvoicesComponent,
        EmailMonthlyAccountingReportComponent,
        DownloadHistoricalInvoicesComponent,
        DownloadAutopayReportComponent,
        DownloadOnetimePmtReportComponent,
        InvoiceListComponent,
        InvoiceAddendumComponent,
        CourtFeesAuditReportComponent,
        ResmanBillingReportComponent,
        AddendumUploadComponent
    ],
    imports: [
        CommonModule,
        PaymentModule,
        ReactiveFormsModule,
        NgbModule,
        NgbdModalModule,
        AngularEditorModule,
        PipesModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        SharedComponentsModule,
        RouterModule.forRoot(routes),
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            preventDuplicates: false,
        }), // ToastrModule added
    ]
})
export class InvoiceModule {
}
